<script>
// import BrandItem from './BrandItem';
import {
  esellerMethods,
  esellerComputed,
  layoutMethods,
  productListComputed,
  productListMethods,
  erpUserRolesMethods
} from "@/state/helpers";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import ImageUploader from "@/components/ImageUploader";
import { getModuleAccess } from '@/router/helper.js'

/**
 * Add Seller Account Brand component
 */
export default {
  page: {
    title: "Add Seller Account Brand",
  },
  data() {
    return {
      title: "Add Seller Account Brand",
      folder:"seller-brands",
      brandId: 0,
      brandLogo: {
        filename: null,
        type: null,
        base64: null,
      },
      isEditModal: false,
      logoPreview: "",
      brand: {
        brandId: null,
        brandName: "",
        brandDescription: "",
        brandBusinessCategories: [],
        brandProductCategories: [],
        brandImageSrc: "",
        orgName: "",
        orgAddress: "",
        orgEmail: "",
        orgPhoneNumber: "",
        shippingRate: 0.0,
        shippingDays: 0,
        brandStatus: 1,
      },
      formExitChecker: {
        brandId: null,
        brandName: "",
        brandDescription: "",
        brandBusinessCategories: [],
        brandProductCategories: [],
        brandImageSrc: "",
        orgName: "",
        orgAddress: "",
        orgEmail: "",
        orgPhoneNumber: "",
        shippingRate: 0.0,
        shippingDays: 0,
        brandStatus: 1,
      },
      redirectForm: true,
      esuppliesSellerModule: {
        access: {
          create: true,
          update: true
        }
      }
    };
  },
  components: {
    // BrandItem,
    Multiselect,
    ImageUploader,
  },
  methods: {
    ...layoutMethods,
    ...esellerMethods,
    ...productListMethods,
    ...erpUserRolesMethods,
    clearLogo() {
      this.brandLogo = {
        filename: null,
        type: null,
        base64: null,
      };
    },
    createBrand() {
      var brandObj = { ...this.brand };
      delete brandObj.brandId;

      if (this.brandLogo.base64) {
        var brandLogo = { ...this.brandLogo };
        brandLogo.folder = this.folder;

        this.uploadLogo(brandLogo)
          .then((imageKey) => {
            brandObj = {
              ...brandObj,
              brandImageSrc: imageKey,
            };

            this.create(brandObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.create(brandObj);
      }
    },
    create(brandObj) {
      this.createSellerBrand(brandObj)
        .then(() => {
          this.redirectForm=false;
          Swal.fire(
            "Create Successful!",
            `${brandObj.brandName} has been created.`,
            "success"
          );
          this.listBrands();
          this.clearLogo();
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "ESeller Brand",
            }
          );
        })
        .catch((e) => {
          console.log("Err::",e);
          Swal.fire(
            "Create Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${brandObj.brandName} was not created.`,
            "error"
          );
          this.clearLogo();
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    listBrands() {
      this.listSellerBrands(this.pagination);
    },
    editBrand(brandId) {
      this.logoPreview = null;
      this.getSellerBrand(brandId).then((brandData) => {
        if (!brandData.brandProductCategories) {
          brandData.brandProductCategories = [];
        }
        this.brand = { ...brandData };
        this.formExitChecker = { ...brandData };
        this.isEditModal = true;
      });
    },
    updateBrand() {
      var brandObj = { ...this.brand };
      brandObj.brandId = brandObj.brandId.toString();
      brandObj.brandImageSrc = brandObj.brandImageKey;
      delete brandObj.brandImage;

      brandObj.brandProductCategories = brandObj.brandProductCategories.map(
        (c) => c.toString()
      );

      delete brandObj.createdBy;
      delete brandObj.createdate;
      delete brandObj.itemCount;
      delete brandObj.modifiedBy;
      delete brandObj.modifiedDate;
      delete brandObj.orgEmail;
      delete brandObj.orgPhoneNumber;

      if (this.brandLogo.base64) {
        var brandLogo = { ...this.brandLogo };
        brandLogo.folder = this.folder;

        this.uploadLogo(brandLogo)
          .then((imageKey) => {
            brandObj = {
              ...brandObj,
              brandImageSrc: imageKey,
            };

            this.update(brandObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.update(brandObj);
      }
    },
    update(brandObj) {
      this.updateSellerBrand(brandObj)
        .then(() => {
          this.isEditModal = false;
          this.redirectForm=false;
          Swal.fire(
            "Update Successful!",
            `${brandObj.brandName} has been updated.`,
            "success"
          );
          this.listBrands();
          this.clearLogo();
          this.formExitChecker == this.brand;
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "ESeller Brand",
            }
          );
        })
        .catch(() => {
          this.isEditModal = false;
          Swal.fire(
            "Update Failed!",
            `${brandObj.brandName} was not updated.`,
            "error"
          );
          this.clearLogo();
        });
    },
    checkForm() {
      if (this.isEditModal) {
        this.updateBrand();
      } else {
        this.createBrand();
      }
    },
    leaveform(next){
        if(JSON.stringify(this.brand) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        } else {
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
        }

    }
  },
  async mounted() {
    this.listProductGroups({ rows: 99999 });
    this.listBrands();
    this.listSellerCategories({ rows: 99999 });
    this.brandId = this.$route.params.id;
    if (this.brandId > 0) {
      this.editBrand(this.brandId);
    }
    this.changeTitle({
      title: (this.brandId > 0 ? "Update" : "Add") + " Seller Account Brand",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "E-Seller", to: { name: "ESeller" } },
        { text: "Brands", to: { name: "ESeller Brand" } },
        { text: "Item", to: { name: "Add Seller Account Brand" } },
      ],
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eSupplies', 'Sellers')
      .then((access) => this.esuppliesSellerModule.access = access);

  },
  computed: {
    ...esellerComputed,
    ...productListComputed,
    brandProductCategories: {
      get() {
        var selected = [];
        this.productCategoryOptions.forEach((pco) => {
          if (this.brand.brandProductCategories.includes(pco.value)) {
            selected.push(pco);
          }
        });
        return selected.length > 0 ? selected : null;
      },
      set(categories) {
        var selected = [];
        categories.forEach((c) => {
          selected.push(c.value);
        });
        this.brand.brandProductCategories = selected;
      },
    },
    brandBusinessCategories: {
      get() {
        var selected = [];
        this.businessCategoryOptions.forEach((bco) => {
          if (this.brand.brandBusinessCategories.includes(bco.value)) {
            selected.push(bco);
          }
        });
        return selected.length > 0 ? selected : null;
      },
      set(businessCategory) {
          var selected = [];
          businessCategory.forEach((c) => {
            selected.push(c.value);
          });
          this.brand.brandBusinessCategories = selected;
      },
    },
    productCategoryOptions: {
      get() {
        return this.productGroups.map((group) => {
          return { text: group.groupName, value: group.groupId };
        });
      },
    },
    businessCategoryOptions: {
      get() {
        return this.categories.map((category) => {
          return {
            text: category.businessCategoryName,
            value: category.businessCategoryId,
          };
        });
      },
    },
  },
  beforeRouteLeave(to, from, next) {
      console.log("><><><><> HEY",this.redirectForm,JSON.stringify(this.brand),JSON.stringify(this.formExitChecker));
      if(this.redirectForm){
        this.leaveform(next);
      }else{
        next();
      }
  }
};
</script>

<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <!-- modal -->
        <div v-if="false">
          <div class="card">
            <div class="card-body" v-if="!isEditModal">
              <div v-if="false">
                This is Add Seller Account Brand New Page {{ brandId }}
              </div>
              <image-upload
                v-model="brandLogo"
                label="Brand Logo"
                :isRequired="true"
              />
            </div>
            <div class="card-body" v-if="isEditModal">
              <image-upload
                v-model="brandLogo"
                :imageSrc="brand.brandImageSrc"
                label="Brand Logo"
                :isRequired="false"
              />
            </div>

            <div class="card-footer card-footer-pink">
              <a>
                <i class="fas fa-image"></i>
                Upload Image
              </a>
            </div>
          </div>
          <!-- end of card-->
        </div>
        <!-- end modal -->
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              class="me-4"
              v-model="brandLogo"
              :isRequired="true"
              :imageSrc="brand.brandImageSrc"
            />
          </div>
          <!-- end of img upload-->
          
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="max-width: 620px">
                <div class="row">
                  <label v-if="(brandId <= 0 || isNaN(brandId)) && !esuppliesSellerModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a brand.</label>
                  <label v-else-if="brandId > 0 && !esuppliesSellerModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a brand.</label>    
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        v-model="brand.brandStatus"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexSwitchCheckDefault"
                        >Active</label
                      >
                    </div>
                  </div>
                  <!--end of brand status-->

                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Brand Name*</label>
                    <validation-provider
                      name="Brand name"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Enter brand name"
                        :state="getValidationState(validationContext)"
                        v-model="brand.brandName"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of brand name-->

                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold"
                      >Brand Description*</label
                    >
                    <validation-provider
                      name="Brand description"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <b-form-textarea
                        class="form-control"
                        placeholder="Enter brand description"
                        v-model="brand.brandDescription"
                        :state="getValidationState(validationContext)"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of brand description-->

                  <div class="col-md-12 mb-4"><hr /></div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold"
                      >Brand Category*</label
                    >
                    <validation-provider
                      name="brandCategory"
                      rules="required"
                      v-slot="{ errors, ariaMsg }"
                    >
                      <multiselect
                        :multiple="true"
                        v-model="brandBusinessCategories"
                        :options="businessCategoryOptions"
                        track-by="value"
                        label="text"
                        name="brandCategory"
                        select-label="Click to select"
                        deselect-label="Click to remove"
                        placeholder="Select brand category"
                        :allow-empty="true"
                        :preselect-first="false"
                        :hide-selected="true"
                        :close-on-select="false"
                        :class="{
                          invalid: errors[0],
                        }"
                      ></multiselect>
                      <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of brand category-->

                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold"
                      >Product Categories*
                    </label>
                    <validation-provider
                      name="productCategory"
                      rules="required"
                      v-slot="{ errors, ariaMsg }"
                    >
                      <multiselect
                        :multiple="true"
                        v-model="brandProductCategories"
                        :options="productCategoryOptions"
                        track-by="value"
                        label="text"
                        name="productCategory"
                        select-label="Click to select"
                        deselect-label="Click to remove"
                        placeholder="Select product categories"
                        :allow-empty="true"
                        :preselect-first="false"
                        :hide-selected="true"
                        :close-on-select="false"
                        :class="{
                          invalid: errors[0],
                        }"
                      ></multiselect>
                      <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of product category-->

                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold"
                      >Organization Name*</label
                    >
                    <validation-provider
                      name="Organization name"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        type="text"
                        class="form-control"
                        v-model="brand.orgName"
                        :state="getValidationState(validationContext)"
                        placeholder="Enter organization name"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of organization name-->

                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold">Address*</label>
                    <validation-provider
                      name="Organization address"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        type="text"
                        class="form-control"
                        v-model="brand.orgAddress"
                        :state="getValidationState(validationContext)"
                        placeholder="Enter organization address"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of address-->

                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold"
                      >Shipping Rate*</label
                    >
                    <validation-provider
                      name="Shipping rate"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <div class="input-group">
                        <span class="input-group-text">₱</span>
                        <b-form-input
                          type="number"
                          step="0.01"
                          class="form-control"
                          :state="getValidationState(validationContext)"
                          v-model="brand.shippingRate"
                          placeholder="Enter shiping rate"
                        />
                      </div>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of shipping rate-->

                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold"
                      >Number of Shipping Days*</label
                    >
                    <validation-provider
                      name="Shipping days"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        type="number"
                        class="form-control"
                        v-model="brand.shippingDays"
                        :state="getValidationState(validationContext)"
                        placeholder="Enter estimated number of days for shipping"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of shipping days-->

                  <div class="col-md-12 mb-3" v-if="!isEditModal">
                    <label class="form-label small fw-bold"
                      >Phone Number*</label
                    >
                    <validation-provider
                      name="Phone number"
                      rules="required|ph-mobile"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        :state="getValidationState(validationContext)"
                        type="text"
                        class="form-control"
                        v-model="brand.orgPhoneNumber"
                        v-mask="'+63##########'"
                        placeholder="Enter organization contact number"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of phone number-->

                  <div class="col-md-12 mb-3" v-if="!isEditModal">
                    <label class="form-label small fw-bold">Email*</label>
                    <validation-provider
                      name="Organization email"
                      rules="required|email"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        :state="getValidationState(validationContext)"
                        type="email"
                        class="form-control"
                        placeholder="Enter organization email"
                        v-model="brand.orgEmail"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of email-->

                  <div class="col-md-12 mb-3" v-if="isEditModal">
                    <label class="form-label small fw-bold"
                      >Phone Number*</label
                    >
                    <b-form-input
                      type="text"
                      class="form-control"
                      v-model="brand.orgPhoneNumber"
                      disabled
                      placeholder="Enter organization contact number"
                    />
                  </div>
                  <!--end of phone number-->

                  <div class="col-md-12 mb-3" v-if="isEditModal">
                    <label class="form-label small fw-bold">Email*</label>
                    <b-form-input
                      type="email"
                      class="form-control"
                      disabled
                      placeholder="Enter organization email"
                      v-model="brand.orgEmail"
                    />
                  </div>
                  <!--end of email-->

                  <div class="col-md-6 mt-3">
                    <b-button :disabled="brandId > 0 ? !esuppliesSellerModule.access.update : !esuppliesSellerModule.access.create"
                      variant="primary"
                      class="w-sm w-100p"
                      type="submit"
                      >Save</b-button
                    >
                  </div>
                  <div class="col-md-6 mt-3">
                    <router-link
                      :to="{ name: 'ESeller Brand', params: {} }"
                      class="tc-white"
                    >
                      <b-button
                        variant="light"
                        class="w-sm w-100p"
                        type="button"
                        >Cancel</b-button
                      >
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> </ValidationObserver
    ><!-- end of validation observer-->
  </div>
  <!-- end of row-->
</template>


<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}
</style>